export const UPDATE_FAVOURITES = 'UPDATE_FAVOURITES';
export const SET_LOADING_FAVOURITES = 'SET_LOADING_FAVOURITES';
export const PUSH_FAVOURITES_PAGE = 'PUSH_FAVOURITES_PAGE';
